import {
    BRIGHT_UID,
    CREDIPLATA_UID,
    ENERGIA_REAL_UID,
    KAM_UID,
    RED_GIRASOL_UID,
    SERFIMEX_UID,
} from 'common/constants';

import financialBrightNew from './Bright/config';
import financialCrediplataNev from './Crediplata/config';
import financialDefaultNew from './Default/config';
import financialEnergiaRealNew from './EnergiaReal/config';
import financialKamNew from './KAM/config';
import financialRedGirasolNew from './RedGirasol/config';
import financialSerfimexNew from './Serfimex/config';

/**
 * Obtiene la configuración del partner
 * Prioriza las configuraciones nuevas (migradas) sobre las legacy
 * @param {string} financierId - ID del financier
 * @returns {Object} Configuración del partner
 */
export default (financierId) => {
    const configs = {
        [BRIGHT_UID]: financialBrightNew,
        [CREDIPLATA_UID]: financialCrediplataNev,
        [ENERGIA_REAL_UID]: financialEnergiaRealNew,
        [KAM_UID]: financialKamNew,
        [RED_GIRASOL_UID]: financialRedGirasolNew,
        [SERFIMEX_UID]: financialSerfimexNew,
    };

    return configs[financierId] || financialDefaultNew;
};
